<template>
  <div v-if="showBottomTab" class="flex-shrink-0">
    <div v-if="showAddToDesktopPopup" class="add-to-desktop-popup" @click="triggerAddToDesktop">
      <div class="popup-content">
        <div class="popup-item with-icon" @click="triggerAddToDesktop">
          添加到桌面
        </div>
        <div class="popup-divider">｜</div>
        <div class="popup-item" @click="triggerAddToDesktop">
          关闭
        </div>
      </div>
    </div>

    <v-bottom-navigation
      grow
      fixed
      class="bottomtab-container"
      v-model="value"
      :class="[
        'cust-style',
        appTheme.bottomShadow && templateIndex != 'dfcp' && 'boderstyle',
        `bottomtab-container-${bottomTemplate}`
      ]"
      :color="$tools.Color($vuetify.theme.themes.light.bottomActiveFrontColor, -10)"
      :dark="$vuetify.theme.themes.light.bottomBgColor === '#000' || appTheme.bottomDarkMode"
      :background-color="bottomBoxBgcColor"
    >
      <template v-for="(item, index) in bottomRoutes">
        <v-btn
          :ripple="false"
          v-if="item.key == 'My'"
          :key="`${index}-router`"
          to="/my"
          :style="index != value ? noActBtnStyle : null"
        >
          <span class="nav-title">{{ item.label }}</span>
          <template v-if="bottomRoutes.length <= 6">
            <div
              v-if="
                noReadMsgCount && setIsEnable('messageCenter') && setIsEnable('manage') && bottomTemplate !== 'forum3'
              "
              class="mail-tips"
            >
              {{ noReadMsgCount }}
            </div>
            <img
              class="ob-icon"
              v-if="bottomTemplate == 'forum3'"
              :src="
                index == value
                  ? `${_cdn}/app/home/forum3/bottom/${item.icon}-act.png`
                  : `${_cdn}/app/home/forum3/bottom/${item.icon}.png`
              "
              alt=""
            />
            <img
              class="ob-icon"
              v-else-if="bottomTemplate == 'ob'"
              :src="
                index == value
                  ? `${_cdn}/app/home/ob/bottom/${item.icon}-act.png`
                  : `${_cdn}/app/home/ob/bottom/${item.icon}.png`
              "
              alt=""
            />
            <img
              class="nox-icon"
              v-else-if="bottomTemplate == 'nox'"
              :src="
                index == value
                  ? `${_cdn}/app/home/nox/bottom/${item.icon}-act.png`
                  : `${_cdn}/app/home/nox/bottom/${item.icon}.png`
              "
              alt=""
            />
            <img
              class="dfcp-icon"
              v-else-if="bottomTemplate == 'dfcp'"
              :src="
                index == value
                  ? `${_cdn}/app/home/dfcp/bottom/${item.icon}-act.png`
                  : `${_cdn}/app/home/dfcp/bottom/${item.icon}.png`
              "
              alt=""
            />
            <i v-else class="iconfont" :class="[item.icon, isDark && 'iconfont-ks']"></i>
          </template>
          <template v-else>
            <div
              v-if="
                noReadMsgCount && setIsEnable('messageCenter') && setIsEnable('manage') && bottomTemplate !== 'forum3'
              "
              class="mail-tips"
            >
              {{ noReadMsgCount }}
            </div>
            <img
              class="ob-icon"
              v-if="bottomTemplate == 'forum3'"
              :src="
                index == value
                  ? `${_cdn}/app/home/forum3/bottom/${item.icon}-act.png`
                  : `${_cdn}/app/home/forum3/bottom/${item.icon}.png`
              "
              alt=""
            />
            <img
              class="ob-icon"
              v-else-if="bottomTemplate == 'ob'"
              :src="
                index == value
                  ? `${_cdn}/app/home/ob/bottom/${item.icon}-act.png`
                  : `${_cdn}/app/home/ob/bottom/${item.icon}.png`
              "
              alt=""
            />
            <img
              class="nox-icon"
              v-else-if="bottomTemplate == 'nox'"
              :src="
                index == value
                  ? `${_cdn}/app/home/nox/bottom/${item.icon}-act.png`
                  : `${_cdn}/app/home/nox/bottom/${item.icon}.png`
              "
              alt=""
            />
            <img
              class="dfcp-icon"
              v-else-if="bottomTemplate == 'dfcp'"
              :src="
                index == value
                  ? `${_cdn}/app/home/dfcp/bottom/${item.icon}-act.png`
                  : `${_cdn}/app/home/dfcp/bottom/${item.icon}.png`
              "
              alt=""
            />
            <i v-else class="iconfont" :class="[item.icon, isDark && 'iconfont-ks']"></i>
          </template>
        </v-btn>
        <template v-else-if="item.key == 'DownloadApp'">
          <div :key="`${index}-router`" @click="toDownload" class="pl-4 pr-4" style="flex: 0 1 auto; width: 100%">
            <v-btn
              active-class
              disabled
              style="position: relative; background-color: transparent !important"
              :style="index != value ? noActBtnStyle : null"
              class="pl-0 pr-0"
            >
              <span class="nav-title">{{ item.label }}</span>
              <img
                class="ob-icon"
                v-if="bottomTemplate == 'forum3'"
                :src="
                  index == value
                    ? `${_cdn}/app/home/forum3/bottom/${item.icon}-act.png`
                    : `${_cdn}/app/home/forum3/bottom/${item.icon}.png`
                "
                alt=""
              />
              <img
                class="ob-icon"
                v-if="bottomTemplate == 'ob'"
                :src="
                  index == value
                    ? `${_cdn}/app/home/ob/bottom/${item.icon}-act.png`
                    : `${_cdn}/app/home/ob/bottom/${item.icon}.png`
                "
                alt=""
              />
              <img
                class="nox-icon"
                v-else-if="bottomTemplate == 'nox'"
                :src="
                  index == value
                    ? `${_cdn}/app/home/nox/bottom/${item.icon}-act.png`
                    : `${_cdn}/app/home/nox/bottom/${item.icon}.png`
                "
                alt=""
              />
              <img
                class="dfcp-icon"
                v-else-if="bottomTemplate == 'dfcp'"
                :src="
                  index == value
                    ? `${_cdn}/app/home/dfcp/bottom/${item.icon}-act.png`
                    : `${_cdn}/app/home/dfcp/bottom/${item.icon}.png`
                "
                alt=""
              />
              <i v-else class="iconfont" :class="[item.icon, isDark && 'iconfont-ks']"></i>
              <div v-if="imNoReadMsgNum > 0 && bottomTemplate !== 'forum3'" class="mail-tips">
                {{ parImNoReadMsgNum }}
              </div>
            </v-btn>
          </div>
        </template>
        <template v-else-if="item.key == 'IM' || item.key == 'im'">
          <div
            :key="`${index}-router`"
            v-if="_sysConfig.is_open_im == '1'"
            @click="toIM"
            class="pl-4 pr-4"
            style="flex: 0 1 auto; width: 100%"
          >
            <v-btn
              active-class
              disabled
              style="position: relative; background-color: transparent !important"
              :style="index != value ? noActBtnStyle : null"
              class="pl-0 pr-0"
            >
              <span class="nav-title">{{ item.label }}</span>
              <img
                class="ob-icon"
                v-if="bottomTemplate == 'forum3'"
                :src="
                  index == value
                    ? `${_cdn}/app/home/forum3/bottom/${item.icon}-act.png`
                    : `${_cdn}/app/home/forum3/bottom/${item.icon}.png`
                "
                alt=""
              />
              <img
                class="ob-icon"
                v-else-if="bottomTemplate == 'ob'"
                :src="
                  index == value
                    ? `${_cdn}/app/home/ob/bottom/${item.icon}-act.png`
                    : `${_cdn}/app/home/ob/bottom/${item.icon}.png`
                "
                alt=""
              />
              <img
                class="nox-icon"
                v-else-if="bottomTemplate == 'nox'"
                :src="
                  index == value
                    ? `${_cdn}/app/home/nox/bottom/${item.icon}-act.png`
                    : `${_cdn}/app/home/nox/bottom/${item.icon}.png`
                "
                alt=""
              />
              <img
                class="dfcp-icon"
                v-else-if="bottomTemplate == 'dfcp'"
                :src="
                  index == value
                    ? `${_cdn}/app/home/dfcp/bottom/${item.icon}-act.png`
                    : `${_cdn}/app/home/dfcp/bottom/${item.icon}.png`
                "
                alt=""
              />
              <i v-else class="iconfont" :class="[item.icon, isDark && 'iconfont-ks']"></i>
              <div
                v-if="imNoReadMsgNum > 0"
                class="mail-tips"
                :class="{ 'mail-tips-forum3': bottomTemplate !== 'forum3' }"
              >
                {{ parImNoReadMsgNum }}
              </div>
            </v-btn>
          </div>
        </template>
        <template v-else-if="item.key == 'Kefu'">
          <div :key="`${index}-router`" @click="toServece" class="pl-4 pr-4" style="flex: 0 1 auto; width: 100%">
            <v-btn
              active-class
              disabled
              style="background-color: transparent !important"
              :style="index != value ? noActBtnStyle : null"
              class="pl-0 pr-0"
            >
              <span class="nav-title">{{ item.label }}</span>
              <img
                class="ob-icon"
                v-if="bottomTemplate == 'ob'"
                :src="
                  index == value
                    ? `${_cdn}/app/home/ob/bottom/${item.icon}-act.png`
                    : `${_cdn}/app/home/ob/bottom/${item.icon}.png`
                "
                alt=""
              />
              <img
                class="nox-icon"
                v-else-if="bottomTemplate == 'nox'"
                :src="
                  index == value
                    ? `${_cdn}/app/home/nox/bottom/${item.icon}-act.png`
                    : `${_cdn}/app/home/nox/bottom/${item.icon}.png`
                "
                alt=""
              />
              <img
                class="dfcp-icon"
                v-else-if="bottomTemplate == 'dfcp'"
                :src="
                  index == value
                    ? `${_cdn}/app/home/dfcp/bottom/${item.icon}-act.png`
                    : `${_cdn}/app/home/dfcp/bottom/${item.icon}.png`
                "
                alt=""
              />
              <i v-else class="iconfont" :class="[item.icon, isDark && 'iconfont-ks']"></i>
            </v-btn>
          </div>
        </template>
        <template v-else-if="item.key == 'Discovery'">
          <div :key="`${index}-router`" class="pl-4 pr-4" style="flex: 0 1 auto; width: 100%">
            <v-menu top right :offset-y="true" z-index="1000">
              <template v-slot:activator="{ on, attrs }">
                <div v-bind="attrs" v-on="on" @click="toDiscovery(item)">
                  <v-btn
                    active-class
                    disabled
                    style="background-color: transparent !important"
                    :style="index != value ? noActBtnStyle : null"
                    class="pl-0 pr-0"
                  >
                    <span class="nav-title">{{ item.label }}</span>
                    <img
                      class="ob-icon"
                      v-if="bottomTemplate == 'forum3'"
                      :src="
                        index == value
                          ? `${_cdn}/app/home/forum3/bottom/${item.icon}-act.png`
                          : `${_cdn}/app/home/forum3/bottom/${item.icon}.png`
                      "
                      alt=""
                    />
                    <img
                      class="ob-icon"
                      v-else-if="bottomTemplate == 'ob'"
                      :src="
                        index == value
                          ? `${_cdn}/app/home/ob/bottom/${item.icon}-act.png`
                          : `${_cdn}/app/home/ob/bottom/${item.icon}.png`
                      "
                      alt=""
                    />
                    <img
                      class="nox-icon"
                      v-else-if="bottomTemplate == 'nox'"
                      :src="
                        index == value
                          ? `${_cdn}/app/home/nox/bottom/${item.icon}-act.png`
                          : `${_cdn}/app/home/nox/bottom/${item.icon}.png`
                      "
                      alt=""
                    />
                    <img
                      class="dfcp-icon"
                      v-else-if="bottomTemplate == 'dfcp'"
                      :src="
                        index == value
                          ? `${_cdn}/app/home/dfcp/bottom/${item.icon}-act.png`
                          : `${_cdn}/app/home/dfcp/bottom/${item.icon}.png`
                      "
                      alt=""
                    />
                    <i v-else class="iconfont" :class="[item.icon, isDark && 'iconfont-ks']"></i>
                  </v-btn>
                </div>
              </template>
              <v-list
                v-if="item.hrefList && item.hrefList.length > 1"
                :color="$vuetify.theme.themes.light.bottomBgColor"
                :dark="$vuetify.theme.themes.light.bottomBgColor === '#000'"
              >
                <v-list-item v-for="hrefItem in item.hrefList" :key="hrefItem.key" @click="toHref(hrefItem)">
                  <v-list-item-title class="text-center">
                    <span style="color: #fff;">{{ hrefItem.label }}</span>
                  </v-list-item-title>
                </v-list-item>
              </v-list>
            </v-menu>
          </div>
        </template>
        <v-btn
          :ripple="false"
          plain
          v-else-if="item.key == 'DsfPlatformList'"
          :key="`${index}-router`"
          :to="`${item.to}?type=${item.params.type}&name=${item.params.title}`"
          :style="index != value ? noActBtnStyle : null"
        >
          <span class="nav-title">{{ item.label }}</span>
          <img
            class="ob-icon"
            v-if="bottomTemplate == 'forum3'"
            :src="
              index == value
                ? `${_cdn}/app/home/forum3/bottom/${item.icon}-act.png`
                : `${_cdn}/app/home/forum3/bottom/${item.icon}.png`
            "
            alt=""
          />
          <img
            class="ob-icon"
            v-else-if="bottomTemplate == 'ob'"
            :src="
              index == value
                ? `${_cdn}/app/home/ob/bottom/${item.icon}-act.png`
                : `${_cdn}/app/home/ob/bottom/${item.icon}.png`
            "
            alt=""
          />
          <img
            class="nox-icon"
            v-else-if="bottomTemplate == 'nox'"
            :src="
              index == value
                ? `${_cdn}/app/home/nox/bottom/${item.icon}-act.png`
                : `${_cdn}/app/home/nox/bottom/${item.icon}.png`
            "
            alt=""
          />
          <img
            class="dfcp-icon"
            v-else-if="bottomTemplate == 'dfcp'"
            :src="
              index == value
                ? `${_cdn}/app/home/dfcp/bottom/${item.icon}-act.png`
                : `${_cdn}/app/home/dfcp/bottom/${item.icon}.png`
            "
            alt=""
          />
          <i v-else class="iconfont" :class="[item.icon, isDark && 'iconfont-ks']"></i>
        </v-btn>
        <template v-else-if="item.key == 'MemberActivity'">
          <v-btn
            v-if="isShowActivityRoom == 1"
            :ripple="false"
            plain
            :key="`${index}-router`"
            :to="`${item.to}?showBottomTab=1`"
            :style="index != value ? noActBtnStyle : null"
          >
            <span class="nav-title">{{ item.label }}</span>
            <img
              class="ob-icon"
              v-if="bottomTemplate == 'forum3'"
              :src="
                index == value
                  ? `${_cdn}/app/home/forum3/bottom/${item.icon}-act.png`
                  : `${_cdn}/app/home/forum3/bottom/${item.icon}.png`
              "
              alt=""
            />
            <img
              class="ob-icon"
              v-else-if="bottomTemplate == 'ob'"
              :src="
                index == value
                  ? `${_cdn}/app/home/ob/bottom/${item.icon}-act.png`
                  : `${_cdn}/app/home/ob/bottom/${item.icon}.png`
              "
              alt=""
            />
            <img
              class="nox-icon"
              v-else-if="bottomTemplate == 'nox'"
              :src="
                index == value
                  ? `${_cdn}/app/home/nox/bottom/${item.icon}-act.png`
                  : `${_cdn}/app/home/nox/bottom/${item.icon}.png`
              "
              alt=""
            />
            <img
              class="dfcp-icon"
              v-else-if="bottomTemplate == 'dfcp'"
              :src="
                index == value
                  ? `${_cdn}/app/home/dfcp/bottom/${item.icon}-act.png`
                  : `${_cdn}/app/home/dfcp/bottom/${item.icon}.png`
              "
              alt=""
            />
            <i v-else class="iconfont" :class="[item.icon, isDark && 'iconfont-ks']"></i>
          </v-btn>
        </template>
        <template v-else-if="item.key == 'OpeningAccountCenter'">
          <v-btn
            :ripple="false"
            plain
            :key="`${index}-router`"
            :to="`${item.to}?showBottomTab=1`"
            :style="index != value ? noActBtnStyle : null"
          >
            <span class="nav-title">{{ item.label }}</span>
            <img
              class="ob-icon"
              v-if="bottomTemplate == 'forum3'"
              :src="
                index == value
                  ? `${_cdn}/app/home/forum3/bottom/${item.icon}-act.png`
                  : `${_cdn}/app/home/forum3/bottom/${item.icon}.png`
              "
              alt=""
            />
            <img
              class="ob-icon"
              v-else-if="bottomTemplate == 'ob'"
              :src="
                index == value
                  ? `${_cdn}/app/home/ob/bottom/${item.icon}-act.png`
                  : `${_cdn}/app/home/ob/bottom/${item.icon}.png`
              "
              alt=""
            />
            <img
              class="nox-icon"
              v-else-if="bottomTemplate == 'nox'"
              :src="
                index == value
                  ? `${_cdn}/app/home/nox/bottom/${item.icon}-act.png`
                  : `${_cdn}/app/home/nox/bottom/${item.icon}.png`
              "
              alt=""
            />
            <img
              class="dfcp-icon"
              v-else-if="bottomTemplate == 'dfcp'"
              :src="
                index == value
                  ? `${_cdn}/app/home/dfcp/bottom/${item.icon}-act.png`
                  : `${_cdn}/app/home/dfcp/bottom/${item.icon}.png`
              "
              alt=""
            />
            <i v-else class="iconfont" :class="[item.icon]"></i>
          </v-btn>
        </template>

        <template v-else-if="item.key == 'PictureWarehouse'">
          <v-btn
            :ripple="false"
            plain
            :key="`${index}-router`"
            :to="`${item.to}?showBottomTab=1`"
            :style="index != value ? noActBtnStyle : null"
          >
            <span class="nav-title">{{ item.label }}</span>
            <img
              class="ob-icon"
              v-if="bottomTemplate == 'forum3'"
              :src="
                index == value
                  ? `${_cdn}/app/home/forum3/bottom/${item.icon}-act.png`
                  : `${_cdn}/app/home/forum3/bottom/${item.icon}.png`
              "
              alt=""
            />
            <img
              class="ob-icon"
              v-else-if="bottomTemplate == 'ob'"
              :src="
                index == value
                  ? `${_cdn}/app/home/ob/bottom/${item.icon}-act.png`
                  : `${_cdn}/app/home/ob/bottom/${item.icon}.png`
              "
              alt=""
            />
            <img
              class="nox-icon"
              v-else-if="bottomTemplate == 'nox'"
              :src="
                index == value
                  ? `${_cdn}/app/home/nox/bottom/${item.icon}-act.png`
                  : `${_cdn}/app/home/nox/bottom/${item.icon}.png`
              "
              alt=""
            />
            <img
              class="dfcp-icon"
              v-else-if="bottomTemplate == 'dfcp'"
              :src="
                index == value
                  ? `${_cdn}/app/home/dfcp/bottom/${item.icon}-act.png`
                  : `${_cdn}/app/home/dfcp/bottom/${item.icon}.png`
              "
              alt=""
            />
            <i v-else class="iconfont" :class="[item.icon]"></i>
          </v-btn>
        </template>

        <v-btn
          :ripple="false"
          plain
          v-else
          :key="`${index}-router`"
          :to="item.to"
          :style="index != value ? noActBtnStyle : null"
        >
          <span class="nav-title">{{ item.label }}</span>
          <img
            class="ob-icon"
            v-if="bottomTemplate == 'forum3'"
            :src="
              index == value
                ? `${_cdn}/app/home/forum3/bottom/${item.icon}-act.png`
                : `${_cdn}/app/home/forum3/bottom/${item.icon}.png`
            "
            alt=""
          />
          <img
            class="ob-icon"
            v-else-if="bottomTemplate == 'ob'"
            :src="
              index == value
                ? `${_cdn}/app/home/ob/bottom/${item.icon}-act.png`
                : `${_cdn}/app/home/ob/bottom/${item.icon}.png`
            "
            alt=""
          />
          <img
            class="nox-icon"
            v-else-if="bottomTemplate == 'nox'"
            :src="
              index == value
                ? `${_cdn}/app/home/nox/bottom/${item.icon}-act.png`
                : `${_cdn}/app/home/nox/bottom/${item.icon}.png`
            "
            alt=""
          />
          <img
            class="dfcp-icon"
            v-else-if="bottomTemplate == 'dfcp'"
            :src="
              index == value
                ? `${_cdn}/app/home/dfcp/bottom/${item.icon}-act.png`
                : `${_cdn}/app/home/dfcp/bottom/${item.icon}.png`
            "
            alt=""
          />
          <i v-else class="iconfont" :class="[item.icon, isDark && 'iconfont-ks']"></i>
        </v-btn>
      </template>
    </v-bottom-navigation>
    <div v-if="holder" class="bottomtab-container" :class="`bottomtab-container-${bottomTemplate}`"></div>
    <Im ref="Im"></Im>
  </div>
</template>

<script>
import Cookie from 'js-cookie'
import appConfigMixins from '@c/mixins/appConfig.mixins'
import axios from 'axios'
import app from '../../store/app'
import any from '~/assets/tools/any.js'
import Im from '@c/Im'
export default {
  mixins: [appConfigMixins],
  components: {
    Im
  },
  props: {
    holder: {
      type: [Boolean],
      default: true
    }
  },
  mounted() {
    this.value = this.indexActiveBottomTab
    this.checkShowAddToDesktopPopup()
  },
  data() {
    return {
      value: null,
      showAddToDesktopPopup: false
    }
  },
  computed: {
    bottomBoxBgcColor() {
      let c75 =
        (this._config.app_config.configValue &&
          this._config.app_config.configValue.template &&
          this._config.app_config.configValue.template.index) ||
        null
      return c75 == 'c75' ? '#f6f6f6' : this.$vuetify.theme.themes.light.bottomBgColor
    },

    noActBtnStyle() {
      const { bottominActiveFrontColor } = this.$vuetify.theme.themes.light
      return {
        color: bottominActiveFrontColor ? `${bottominActiveFrontColor} !important` : undefined
      }
    },
    // APP下载地址
    app_address() {
      return this.$store.state.sysParameter.app_address
    },
    indexActiveBottomTab() {
      const name = this.$route.name
      const path = this.$route.path
      const routerKey = this.$route.query.key
      if (routerKey) {
        let index = this.bottomRoutes.findIndex(item => item.screen.toLowerCase() == routerKey.toLowerCase())
        return index
      } else if (name !== 'home') {
        let index = this.bottomRoutes.findIndex(item => item.to.toLowerCase() == path.toLowerCase())
        return index
      } else {
        return 0
      }
    },
    AddToDesktopPopup() {
      try {
        return this._config.app_config.configValue.showAddToDesktopPopup
      } catch (error) {
        return ''
      }
    },
    showBottomTab() {
      return this.$store.state.app.showBottomTab
    },
    noReadMsgCount() {
      let noReadMsgCount = this.$store.state.user.noReadMsgCount
      if (noReadMsgCount > 99) {
        return '···'
      } else {
        return noReadMsgCount
      }
    },
    templateIndex() {
      try {
        return this._config.app_config.configValue.template.index || 'default1'
      } catch {
        return 'default1'
      }
    },
    appTheme() {
      return this._config.app_config.configValue.app_theme || JSON.parse(localStorage.NEWAPPCONFIG)
    },
    bottomTemplate() {
      try {
        return this._config.app_config.configValue.template.tabbarTemplate
      } catch (error) {
        return ''
      }
    },
    // bottomTabs() {
    //   return this.$store.state.app.appConfig.app_config.configValue.bottomTabs
    //     .value;
    // },
    token() {
      let token = this.$store.state.user.token || Cookie.get('TOKEN')
      return token || ''
    },
    userInfo() {
      return this.$store.state.user.userInfo
    },
    onlineQQUrl() {
      //在线客服地址
      return this.$store.state.sysParameter.onlineQQUrl
    },
    imNoReadMsgNum() {
      return (
        this.$store.getters['user/getImRecentNoReadMsgNum'] + this.$store.getters['user/getImFriendApplyLogNoReadNum']
      )
    },
    parImNoReadMsgNum() {
      if (this.imNoReadMsgNum > 99) {
        return '···'
      } else {
        return this.imNoReadMsgNum
      }
    },
    bottomRoutes() {
      //console.error(this.bottom_router, 'this.bottom_router')
      return this.bottom_router
    }
  },
  methods: {
    init() {
      if (this.$store.state.user.token) {
        this.$store.dispatch('user/loopGetNoReadMsgCount')
      }
    },
    getBottomTabs() {
      try {
        let tabs = [];
        this.bottomTabs.forEach((route) => {
          let item = this.router.find((e) => {
            if(e.key === 'IM') {
              return e.key == route.screen && route.platform != "app"&& this._sysConfig.is_open_im == '1'
            } else {
              return e.key == route.screen && route.platform != "app"
            }
          });
          if (item) {
            tabs.push({
              ...item,
              ...route,
            });
          }
        });
        return tabs;
      } catch {
        console.warn("tabs 配置有误");
        return this.router;
      }
    },
    checkApiAddress() {
      return new Promise((resolve, reject) => {
        //检测可用域名
        const promiseList = this.imApiDomainList.map(imDomain => {
          return new Promise((resolve, reject) => {
            axios
              .post(`${imDomain}/melody/api/v1/base/heartbeat`)
              .then(res => {
                const code = res.data ? res.data.code : ''
                if (code == '12200') {
                  resolve(imDomain)
                } else {
                  reject(imDomain)
                }
              })
              .catch(e => {
                reject(e)
              })
          })
        })
        any(promiseList)
          .then(res => {
            resolve(res)
          })
          .catch(e => {
            reject(e)
          })
      })
    },
    toDownload() {
      window.open(this.app_address)
    },
    toIM() {
      const ImCon = this.$refs['Im']
      if (ImCon) {
        ImCon.toIM()
      }
    },
    toServece() {
      window.open(this.onlineQQUrl)
    },
    toDiscovery(item) {
      if (item.hrefList.length == 1) {
        if (item.isH5Embedded == 1) {
          // 从app打开
          this.$router.push({ path: '/discovery' })
        } else {
          this.toHref(item.hrefList[0])
        }
        // window.open(item.hrefList[0].href)
      }
    },
    toHref(hrefItem) {
      console.log('hrefItem', hrefItem)
      if (hrefItem.needLoginTipsFunction && hrefItem.needLoginTipsFunction !== 'none') {
        this.toPush(hrefItem)
      } else {
        window.open(hrefItem.href)
      }
    },
    // 跳转
    toPush(hrefItem) {
      if (this.token && this.userInfo) {
        window.open(hrefItem.href)
      } else {
        if (hrefItem.needLoginTipsFunction === 'toLogin') {
          this.$router.push({ path: '/login' }) // 跳转登陆页
        } else if (hrefItem.needLoginTipsFunction === 'toRegister') {
          this.$router.push({ path: '/pages/register/register' }) // 跳转注册页
        } else if (hrefItem.needLoginTipsFunction === 'tips') {
          this.$toast('请登录后操作')
        }
      }
    },

    checkShowAddToDesktopPopup() {
      const isIOS = /iPhone|iPad|iPod/i.test(navigator.userAgent)
      const isSafari = /^((?!chrome|android).)*safari/i.test(navigator.userAgent)
      const isMobileSafari = isIOS && isSafari
      console.log(isSafari, isMobileSafari, '=========23232')
      // 判断是否在桌面
      const isPWA = window.matchMedia('(display-mode: standalone)').matches
      const hasShown = localStorage.getItem('addToDesktopPopupShown')
      let AddToDesktopPopup = this.AddToDesktopPopup == 1
      this.showAddToDesktopPopup = isMobileSafari && !isPWA && !hasShown && AddToDesktopPopup
    },

    triggerAddToDesktop() {
      this.showAddToDesktopPopup = false
      localStorage.setItem('addToDesktopPopupShown', 'true')
    },
    CloseTriggerAddToDesktop() {
      this.showAddToDesktopPopup = false
    }
  },
  created() {
    this.init()
    document.addEventListener('visibilitychange', this.updateImNoread)
  },
  destroyed() {
    clearInterval(this.imNoreadTimer)
    document.removeEventListener('visibilitychange', this.updateImNoread)
  }
}
</script>
<style lang="scss">
.bottomtab-container {
  height: 56px !important;
  align-items: center;

  .nav-title {
    font-size: 14px;
    margin-top: 4px;
  }

  .iconfont {
    font-size: 20px;
  }

  //   .iconfont-ks {
  //     font-size: 20px;
  //   }

  .v-btn {
    min-width: auto !important;
  }

  .mail-tips {
    padding: 0 4px;
    min-width: 18px;
    height: 18px;
    font-size: 12px;
    border-radius: 18px;
    background-color: #f44336;
    color: #fff;
    display: flex;
    justify-content: center;
    align-items: center;
    position: absolute;
    right: 0;
    top: 0;
    font-weight: bold;
  }

  .mail-tips-forum3 {
    right: auto;
    left: 27px;
  }
}

.bottomtab-container-ob {
  font-family: 'PFOB' !important;
  height: 60px !important;

  .v-btn:before {
    content: none !important;
  }

  .nav-title {
    font-size: 12px !important;
  }

  .ob-icon {
    width: 24px;
    height: 24px;
  }
}

.bottomtab-container-ob.theme--light.v-bottom-navigation .v-btn:not(.v-btn--active) {
  color: #98a7b5 !important;
}

.bottomtab-container-nox {
  .nav-title {
    font-size: 12px !important;
  }

  .nox-icon {
    width: 24px;
    height: 24px;
  }
}

.bottomtab-container {
  .nav-title {
    font-size: 12px !important;
  }

  .dfcp-icon {
    width: 24px;
    height: 24px;
  }
}

.bottomtab-container-nox.theme--light.v-bottom-navigation .v-btn:not(.v-btn--active) {
  color: #c8aed9 !important;
}

.boderstyle {
  border-radius: 16px 16px 0 0;
}

.cust-style {
  justify-content: space-around !important;

  .pl-4,
  .pr-4 {
    padding-left: 0 !important;
    padding-right: 0 !important;
    flex: none !important;
    width: auto !important;
  }

  .v-btn {
    width: auto !important;
    padding: 0 !important;
  }
}

.bottomtab-container-forum3 {
  justify-content: space-around !important;

  .pl-4,
  .pr-4 {
    padding-left: 0 !important;
    padding-right: 0 !important;
    flex: none !important;
    width: auto !important;
  }

  .v-btn {
    width: auto !important;
    padding: 0 !important;
  }

  .v-btn:before {
    content: none !important;
  }

  .nav-title {
    font-size: 10px !important;
    color: #999 !important;
    font-weight: 400;
  }

  .v-btn__content {
    img {
      height: 22px;
      width: auto;
    }
  }

  .v-btn--active {
    margin-bottom: 20px !important;

    .nav-title {
      color: #333 !important;
    }

    .ob-icon {
      height: 38px;
    }
  }
}

.bottomtab-container-forum3.theme--light.v-bottom-navigation .v-btn:not(.v-btn--active) {
  color: #999 !important;
}

.add-to-desktop-popup {
  width: 200px;
  position: fixed;
  bottom: 10px;
  /* 调整位置避免遮挡底部导航 */
  left: 50%;
  transform: translateX(-50%);
  background-color: #fff;
  color: #333;
  padding: 8px 16px;
  border-radius: 5px;
  font-size: 14px;
  font-weight: bold;
  z-index: 999;
  box-shadow: 0 2px 10px rgba(0, 0, 0, 0.2);
  animation: floatUp 0.3s ease-out;
  cursor: pointer;

  .popup-content {
    display: flex;
    align-items: center;
    justify-content: center;
  }

  .popup-item {
    padding: 0 2px;
    cursor: pointer;

    &:hover {
      opacity: 0.8;
    }
  }

  popup-item.with-icon {
    display: inline-flex;
    align-items: center;
    position: relative;
    padding: 8px 16px;
    cursor: pointer;
  }

  .popup-item.with-icon::before {
    content: '+';
    color: red;
    display: inline-flex;
    align-items: center;
    justify-content: center;
    width: 18px;
    height: 18px;
    border: 1px solid currentColor;
    border-radius: 50%;
    margin-right: 8px;
    font-size: 12px;
    line-height: 1;
    position: relative;
    top: -1px;
  }

  .popup-divider {
    padding: 0 4px;
    color: red;
  }

  &:after {
    content: '';
    position: absolute;
    bottom: -8px;
    left: 50%;
    transform: translateX(-50%);
    width: 0;
    height: 0;
    border-left: 8px solid transparent;
    border-right: 8px solid transparent;
    border-top: 8px solid #fff;
  }

  @keyframes floatUp {
    from {
      opacity: 0;
      transform: translateX(-50%) translateY(10px);
    }

    to {
      opacity: 1;
      transform: translateX(-50%) translateY(0);
    }
  }
}
</style>
